// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"37618f89","453":"68693753","455":"42935a6e","977":"6e17b5c8"}[chunkId] + ".chunk.js";
};